module.exports = __webpack_public_path__ + "img/img14.8dc33c9e.svg";